import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

import {analyticsInit} from "./utils/analytics";
import {initRouter} from "./router/init";
import App from "./App";
import BootFailure from "./components/BootFailure";

analyticsInit();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

initRouter()
  .then(() => root.render(<App />))
  .catch((error: unknown) => {
    // The app shell's own chunk could not be loaded even after retries — the
    // client is offline or something is blocking the request. Render a minimal
    // static screen rather than leave a blank page and a silent unhandled
    // rejection.
    //
    // Report it only when the tab is visible. These boot failures are
    // overwhelmingly hidden-tab ones: a load abandoned by navigating away or
    // closing the tab before the shell arrived, which no one saw. A visible tab
    // means someone is waiting on the screen, so a genuine failure still
    // reports. This knowingly drops the rarer case of a backgrounded tab brought
    // back to a still-broken BootFailure — accepted as the cost of silencing the
    // noise, since nothing here re-attempts the load on refocus.
    if (document.visibilityState !== "hidden") {
      Sentry.captureException(error);
    }
    root.render(<BootFailure />);
  });
